import type {
  PublicAssetFrontendApi$AssetComponentDto,
  PublicAssetFrontendApi$AssetComponents,
} from '@/custolink-transpiled_by_server/bc.asset_interaction.api_methods'

/** How many of the highest-priority components get a big support box. */
export const SUPPORT_BOXES = 3

/**
 * The shared page structure of the home and the asset view: every visible
 * component, highest UI priority first (set per component in the admin). The
 * top three become the support boxes; the rest split into actions and
 * documentation, keeping that order.
 */
export function layoutComponents(sections: PublicAssetFrontendApi$AssetComponents | null | undefined) {
  const all: PublicAssetFrontendApi$AssetComponentDto[] = [
    ...(sections?.topSection ?? []),
    ...(sections?.middleSection ?? []),
    ...(sections?.bottomSection ?? []),
  ].sort((a, b) => b.uiPriority - a.uiPriority)
  const rest = all.slice(SUPPORT_BOXES)
  return {
    all,
    support: all.slice(0, SUPPORT_BOXES),
    /** Everything after the support boxes, in priority order. */
    rest,
    actions: rest.filter((c) => !c.filesystemComponent),
    docs: rest.filter((c) => c.filesystemComponent),
  }
}
